export enum EUserRole {
  owner = 'owner',
  admin = 'admin',
  user = 'user'
}
